<block>
    <block-title>
        {{ 'news.label' | translate }}
    </block-title>
    <block-content>
        <listItems [list]="list" type="news"></listItems>
    </block-content>
</block>

